module.exports = __webpack_public_path__ + "static/media/2.b39cf222.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/lhand/2.png
// module id = 1333
// module chunks = 0